export enum BrainBankErrorCode {
    DatasetBusy = 'DATASET_BUSY',
    DatasetNotFound = 'DATASET_NOT_FOUND',
    BrainNotFound = 'BRAIN_NOT_FOUND',
    InvalidCredentials = 'INVALID_CREDENTIALS',
    UserAlreadyExists = 'USER_ALREADY_EXISTS',
    AssetNotFound = 'ASSET_NOT_FOUND',
    AccountLocked = 'ACCOUNT_LOCKED',
    RoiNotFound = 'ROI_NOT_FOUND'
}

export const SYSTEM_IS_BUSY_MESSAGE =
    'The system is busy completing an on-going job, and cannot perform the requested action. Please try again once the current job is complete.';



// WEBPACK FOOTER //
// ./src/providers/error-code.ts